$(document).foundation();

var pageDimensions = {
  sidebarHeight: 0,
  breadcrumbHeight: 0,
  headerHeight: 0,
};

var blockSettings = {
  postGrid: {
    scrollOffset: 0,
  }
};

//dimensions
pageDimensions.headerHeight = $('header').outerHeight();
$('body').css('--header-height', pageDimensions.headerHeight+'px');

pageDimensions.mobileSidebarHeight = $('.mobile-sidebar').outerHeight();
if (typeof pageDimensions.mobileSidebarHeight != 'undefined') {
  $('body').css('--mobile-sidebar-height', pageDimensions.mobileSidebarHeight+'px');
} else {
  $('body').css('--mobile-sidebar-height', '0px');
}

pageDimensions.sidebarHeight = $('.outer-container .sidebar-container').outerHeight();
if (typeof pageDimensions.sidebarHeight != 'undefined') {
  $('body').css('--sidebar-height', pageDimensions.sidebarHeight+'px');
}

pageDimensions.breadcrumbHeight = $('.breadcrumb-container').outerHeight();    
if (typeof pageDimensions.breadcrumbHeight != 'undefined') {
  $('body').css('--breadcrumb-height', pageDimensions.breadcrumbHeight+'px');
}

$(document).ready(function($) {

  // headroom
  var headroom  = new Headroom(document.querySelector("header"));
  headroom.init();  

  // nav menu
  $('.menu-toggle').on("click", function(e) {
    e.preventDefault();
    $('.mobile-navigation').toggleClass('is-active');
  });

  // blocks
  $('.post-grid-pager a').on('click', function() {
    var $current = $(this);
    var page = $current.data('page');
    var $postContainer = $current.parents('.post-grid-pager').siblings('.post-grid');
    var pageCount = parseInt($postContainer.data('page-count'));
    if ($current.is('.active') || $current.is('.disabled')) return;
    switch (page) {
      case 'prev':
        var currentPage = $postContainer.data('current-page');
        if (parseInt(currentPage) > 1) {
          $current.siblings('[data-page='+(currentPage-1)+']').trigger('click');
        }
        break;
      case 'next':
        var currentPage = $postContainer.data('current-page');
        if (parseInt(currentPage) < pageCount) {
          $current.siblings('[data-page='+(currentPage+1)+']').trigger('click');
        }
        break;
      case 'first':
        break;
      case 'last':
        break;
      default: // page numbers
        $current.siblings().removeClass('active');
        $current.addClass('active');
        if (page == 1) {
          $current.siblings('[data-page="prev"]').addClass('disabled');
          $current.siblings('[data-page="next"]').removeClass('disabled');
        } else if (page == pageCount) {
          $current.siblings('[data-page="prev"]').removeClass('disabled');
          $current.siblings('[data-page="next"]').addClass('disabled');
        } else {
          $current.siblings('[data-page="prev"]').removeClass('disabled');
          $current.siblings('[data-page="next"]').removeClass('disabled');
        }
        $postContainer.data('current-page', page);
        $postContainer.find('.post-grid-item').addClass('hide');
        $postContainer.find('.post-grid-item[data-page="'+page+'"]').removeClass('hide');
    }
    $('html,body').animate({scrollTop: $postContainer.offset().top - blockSettings.postGrid.scrollOffset}, 500);  
  });

  // filtering
  $('[data-filter-for]').on("click", function(e) {
    e.preventDefault();
    var $targetContainer = $($(this).data('filter-for'));
    var criteria = $(this).data('filter-criteria');
    var filterValue = $(this).data('filter-value');
    $(this).siblings().removeClass('filter-criteria-selected');
    $(this).addClass('filter-criteria-selected');
    if (filterValue == '.') {
      $targetContainer.find('[data-filter-'+criteria+']').addClass('filter-selected');
    } else {
      $targetContainer.find('[data-filter-'+criteria+']').each(function() {
        var values = $(this).data('filter-'+criteria).split(',');
        var includeInResult = false;
        $.each(values, function() {
          if (this == filterValue) includeInResult = true;
        });
        if (includeInResult) {
          $(this).addClass('filter-selected');
        } else {
          $(this).removeClass('filter-selected');
        }
      });  
    }
    $(this).parents('.filter-container').trigger('ccm.filter.done', [$(this)]);
  });

  // fullscreen on flickity
  $('.flickity-enabled.fullscreen-enabled').on("staticClick.flickity", function(e) {
    $(this).find('.flickity-fullscreen-button.flickity-fullscreen-button-view').trigger("click");
  });

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  });

})
